import React from "react";

const NotFound = () => {
  return (
    <div>
      <p>Sorry this page doesn't exist</p>
    </div>
  );
};

export default NotFound;
